// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"288":"9461d2ea","463":"c1e5a4b1","621":"54e3435d","787":"d0aae870","988":"858cfa1c"}[chunkId] + ".chunk.js";
};